import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
export type Maybe<T> = T | null | undefined;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
    };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Date: { input: string; output: string };
  JSON: { input: any; output: any };
  JSONObject: { input: Record<string, any>; output: Record<string, any> };
  Upload: { input: File; output: File };
};

/** Accept invite response with redirect */
export type AcceptInviteMutationResponse = {
  redirect?: Maybe<RedirectType>;
  success?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Billing account */
export type Account = {
  admin_rights?: Maybe<Scalars["Boolean"]["output"]>;
  assessments?: Maybe<Scalars["Boolean"]["output"]>;
  config?: Maybe<Scalars["JSONObject"]["output"]>;
  dimensions?: Maybe<Array<Maybe<Scalars["JSONObject"]["output"]>>>;
  id?: Maybe<Scalars["Int"]["output"]>;
  is_owner?: Maybe<Scalars["Boolean"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  positions?: Maybe<Scalars["Boolean"]["output"]>;
  projects?: Maybe<Scalars["Boolean"]["output"]>;
  /** This is field is deprecated and always returns null */
  subscription?: Maybe<AccountSubscriptionDetails>;
  teams?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Contact details for the user who gets billed */
export type AccountBillingUser = {
  avatar_url?: Maybe<Scalars["String"]["output"]>;
  email?: Maybe<Scalars["String"]["output"]>;
  first_name?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  initials?: Maybe<Scalars["String"]["output"]>;
  last_name?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
};

export type AccountSubscriptionDetails = {
  allowedProfiles?: Maybe<Scalars["Int"]["output"]>;
  billingUser?: Maybe<AccountBillingUser>;
  isOwner?: Maybe<Scalars["String"]["output"]>;
  seatsUsed?: Maybe<Scalars["Int"]["output"]>;
  type?: Maybe<Scalars["String"]["output"]>;
};

/** Survey */
export type ActiveSurvey = {
  blocks_count?: Maybe<Scalars["Int"]["output"]>;
  complete?: Maybe<Scalars["Boolean"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  duration?: Maybe<Scalars["String"]["output"]>;
  hasIntro?: Maybe<Scalars["Boolean"]["output"]>;
  icon?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  intro?: Maybe<Scalars["JSONObject"]["output"]>;
  main_text?: Maybe<Scalars["String"]["output"]>;
  rows_count?: Maybe<Scalars["Int"]["output"]>;
  survey_rows?: Maybe<Array<Maybe<SurveyRowLoaded>>>;
  text_tid?: Maybe<Scalars["String"]["output"]>;
  type?: Maybe<Scalars["String"]["output"]>;
  ui_template?: Maybe<Scalars["String"]["output"]>;
};

export type AddPersonInput = {
  account_access_level?: InputMaybe<WorkspaceAccessLevel>;
  account_role?: InputMaybe<WorkspaceRoles>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  first_name?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  last_name?: InputMaybe<Scalars["String"]["input"]>;
  linkedin?: InputMaybe<Scalars["String"]["input"]>;
  linkedin_data?: InputMaybe<Scalars["JSON"]["input"]>;
  organization?: InputMaybe<OrganizationRelationInput>;
  project?: InputMaybe<ProjectRelationObjectInput>;
  send_invite?: InputMaybe<InviteInput>;
  team?: InputMaybe<TeamRelationObjectInput>;
};

export type Assessment = {
  created_at?: Maybe<Scalars["Date"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  person?: Maybe<Person>;
  project_id?: Maybe<Scalars["Int"]["output"]>;
  scorecard?: Maybe<Scorecard>;
  summary?: Maybe<Scalars["String"]["output"]>;
};

export type AssessmentEvaluation = {
  assessment_id?: Maybe<Scalars["Int"]["output"]>;
  created_at?: Maybe<Scalars["Date"]["output"]>;
  created_by?: Maybe<Scalars["Int"]["output"]>;
  evaluation?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  meta?: Maybe<Scalars["JSONObject"]["output"]>;
  person_id?: Maybe<Scalars["Int"]["output"]>;
  row_id?: Maybe<Scalars["Int"]["output"]>;
};

export type AssessmentNote = {
  assessment_id?: Maybe<Scalars["Int"]["output"]>;
  created_at?: Maybe<Scalars["Date"]["output"]>;
  created_by?: Maybe<Person>;
  id?: Maybe<Scalars["Int"]["output"]>;
  note?: Maybe<Scalars["String"]["output"]>;
  person_id?: Maybe<Scalars["Int"]["output"]>;
  row_id?: Maybe<Scalars["Int"]["output"]>;
  type?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
};

export type AssessmentOrder = {
  assessment_link?: Maybe<Scalars["String"]["output"]>;
  assessment_type?: Maybe<Scalars["String"]["output"]>;
  completed_at?: Maybe<Scalars["String"]["output"]>;
  created_at?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  redirect_url?: Maybe<Scalars["String"]["output"]>;
  status?: Maybe<Scalars["String"]["output"]>;
  survey?: Maybe<Survey>;
  updated_at?: Maybe<Scalars["String"]["output"]>;
};

export type AssessmentRowDimensionInput = {
  dim_id?: InputMaybe<Scalars["Int"]["input"]>;
  target_max?: InputMaybe<Scalars["Int"]["input"]>;
  target_min?: InputMaybe<Scalars["Int"]["input"]>;
};

export type AssessmentSurvey = {
  assessment_type?: Maybe<Scalars["String"]["output"]>;
  group?: Maybe<Scalars["String"]["output"]>;
};

export type AssessmentSurveyAnswerInput = {
  answer: Scalars["Int"]["input"];
  duration_ms?: InputMaybe<Scalars["Int"]["input"]>;
  question_dim_id: Scalars["Int"]["input"];
};

export type AssessmentSurveyRow = {
  answer?: Maybe<Scalars["Int"]["output"]>;
  block_id?: Maybe<Scalars["Int"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  question_dim_id?: Maybe<Scalars["Int"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type Attachment = {
  content_type?: Maybe<Scalars["String"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  file_name?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  isEmbedded?: Maybe<Scalars["Boolean"]["output"]>;
  tags?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
};

export type AttachmentsFilter = {
  person_id?: InputMaybe<Scalars["Int"]["input"]>;
  position_id?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A dimension text */
export type DimText = {
  /** low, mid, high */
  bucket?: Maybe<Scalars["String"]["output"]>;
  dim_id?: Maybe<Scalars["Int"]["output"]>;
  /** The priority of the text in the bucket. Default is 1. */
  display_order?: Maybe<Scalars["Int"]["output"]>;
  text?: Maybe<Scalars["String"]["output"]>;
  type?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Deprecated in favor of bucket. Will be removed in future releases. */
  value?: Maybe<Scalars["Int"]["output"]>;
};

/** A dimension */
export type Dimension = {
  code?: Maybe<Scalars["String"]["output"]>;
  dim_id?: Maybe<Scalars["Int"]["output"]>;
  group?: Maybe<Scalars["String"]["output"]>;
  group_title?: Maybe<Scalars["String"]["output"]>;
  parent?: Maybe<Scalars["String"]["output"]>;
  parent_id?: Maybe<Scalars["Int"]["output"]>;
  parent_title?: Maybe<Scalars["String"]["output"]>;
  scores?: Maybe<Array<Maybe<Score>>>;
  type?: Maybe<Scalars["String"]["output"]>;
};

/** The dimension object */
export type DimensionLoaded = {
  answer?: Maybe<SurveyAnswerObject>;
  behaviours?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  description_neg?: Maybe<Scalars["String"]["output"]>;
  description_pos?: Maybe<Scalars["String"]["output"]>;
  description_short?: Maybe<Scalars["String"]["output"]>;
  description_tid?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  name_neg?: Maybe<Scalars["String"]["output"]>;
  name_pos?: Maybe<Scalars["String"]["output"]>;
  question_left?: Maybe<Scalars["String"]["output"]>;
  question_opposite_tid?: Maybe<Scalars["String"]["output"]>;
  question_right?: Maybe<Scalars["String"]["output"]>;
  question_tid?: Maybe<Scalars["String"]["output"]>;
};

export type DimensionsFilter = {
  group?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  people?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  personal?: InputMaybe<Scalars["Boolean"]["input"]>;
  position_id?: InputMaybe<Scalars["Int"]["input"]>;
  team_id?: InputMaybe<Scalars["Int"]["input"]>;
  type?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type InviteInput = {
  org_id: Scalars["Int"]["input"];
  project_id?: InputMaybe<Scalars["Int"]["input"]>;
  team_id?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Mutation response with message and mutated object ids. */
export type MutationResponse = {
  /** The list on ids of the mutated objects. This is available for CRUD mutations for bulk and single operations. For agregated utility mutations this will be empty. */
  ids?: Maybe<Array<Maybe<Scalars["Int"]["output"]>>>;
  message?: Maybe<Scalars["String"]["output"]>;
  success?: Maybe<Scalars["Boolean"]["output"]>;
};

/** A note */
export type Note = {
  assessment_id?: Maybe<Scalars["Int"]["output"]>;
  created_by?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  person_id?: Maybe<Scalars["Int"]["output"]>;
  row_id?: Maybe<Scalars["Int"]["output"]>;
  text?: Maybe<Scalars["String"]["output"]>;
  type?: Maybe<Scalars["String"]["output"]>;
};

export type NotesFilter = {
  assessment_id?: InputMaybe<Scalars["Int"]["input"]>;
  position_id?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Notification type */
export type Notification = {
  id?: Maybe<Scalars["Int"]["output"]>;
  message?: Maybe<Scalars["String"]["output"]>;
  type?: Maybe<Scalars["String"]["output"]>;
  url?: Maybe<Scalars["String"]["output"]>;
};

export type OrganizationAccessLevel = "EDIT" | "FULL" | "LIMITED" | "NONE";

export type OrganizationRelationInput = {
  access_level?: InputMaybe<OrganizationAccessLevel>;
  id: Scalars["Int"]["input"];
  role?: InputMaybe<OrganizationRoles>;
};

export type OrganizationRoles = "ADMIN" | "CANDIDATE" | "MEMBER";

export type OrganizationType = {
  admin_rights?: Maybe<Scalars["Boolean"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  people?: Maybe<Array<Maybe<Scalars["Int"]["output"]>>>;
  projects?: Maybe<Array<Maybe<Scalars["Int"]["output"]>>>;
  teams?: Maybe<Array<Maybe<Scalars["Int"]["output"]>>>;
};

export type PeopleFilter = {
  org_id?: InputMaybe<Scalars["Int"]["input"]>;
  project_id?: InputMaybe<Scalars["Int"]["input"]>;
  team_id?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Administration capabilities for the authorized person on a specific resource (invite/change role/access/revoke). */
export type PermissionAdministration = {
  can_change_access_level?: Maybe<Scalars["Boolean"]["output"]>;
  can_change_role?: Maybe<Scalars["Boolean"]["output"]>;
  can_invite?: Maybe<Scalars["Boolean"]["output"]>;
  can_revoke?: Maybe<Scalars["Boolean"]["output"]>;
  constraints?: Maybe<PermissionAdministrationConstraints>;
  grantable_access_levels?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  grantable_roles?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  /** Unique identifier for client-side caching. */
  id?: Maybe<Scalars["String"]["output"]>;
  max_grant_access_level?: Maybe<Scalars["String"]["output"]>;
  max_grant_role?: Maybe<Scalars["String"]["output"]>;
};

/** Structured constraints the client can use for safe permission admin UX. */
export type PermissionAdministrationConstraints = {
  notes?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  organization_full_implies_admin?: Maybe<Scalars["Boolean"]["output"]>;
  workspace_admin_edit_no_manage_people?: Maybe<Scalars["Boolean"]["output"]>;
};

/** A person */
export type Person = {
  assessment_orders?: Maybe<Array<Maybe<AssessmentOrder>>>;
  avatar?: Maybe<Scalars["String"]["output"]>;
  completed_dim_types?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  email?: Maybe<Scalars["String"]["output"]>;
  first_name?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  initials?: Maybe<Scalars["String"]["output"]>;
  invite?: Maybe<PersonInvite>;
  is_contact?: Maybe<Scalars["Boolean"]["output"]>;
  is_guest?: Maybe<Scalars["Boolean"]["output"]>;
  last_name?: Maybe<Scalars["String"]["output"]>;
  linkedin?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  phone?: Maybe<Scalars["String"]["output"]>;
  roles?: Maybe<Array<Maybe<PersonRole>>>;
  /** @deprecated This field is deprecated. Use notes instead */
  summary?: Maybe<Summary>;
  survey_completion?: Maybe<Array<Maybe<SurveyCompletion>>>;
};

/** An invite */
export type PersonInvite = {
  created_at?: Maybe<Scalars["String"]["output"]>;
  secret?: Maybe<Scalars["String"]["output"]>;
};

/** A person note */
export type PersonNoteType = {
  created_at?: Maybe<Scalars["Date"]["output"]>;
  created_by?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  note?: Maybe<Scalars["String"]["output"]>;
  person_id?: Maybe<Scalars["Int"]["output"]>;
  type?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
};

export type PersonNotesFilter = {
  person_id?: InputMaybe<Scalars["Int"]["input"]>;
  type?: InputMaybe<Scalars["String"]["input"]>;
};

/** A list object of roles for a person */
export type PersonRole = {
  /** The access control of the person. */
  access_level?: Maybe<Scalars["String"]["output"]>;
  /** The actions the person has for the role. */
  actions?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  /** People administration capabilities for the authorized user on this resource (invite/change role/access/revoke). */
  administration?: Maybe<PermissionAdministration>;
  /** The context identifier for the role. */
  id?: Maybe<Scalars["String"]["output"]>;
  /** The context object identifier. */
  obj_id?: Maybe<Scalars["Int"]["output"]>;
  /** This field is needed to have a unique identifier for the role for Apollo Client caching. */
  person_id?: Maybe<Scalars["Int"]["output"]>;
  /** The role of the person. */
  role?: Maybe<Scalars["String"]["output"]>;
  /** The context type of role. */
  type?: Maybe<Scalars["String"]["output"]>;
};

/** Position kanban step */
export type PositionKanbanStep = {
  action?: Maybe<Scalars["String"]["output"]>;
  actionTitle?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  people?: Maybe<Array<Maybe<Scalars["Int"]["output"]>>>;
  title?: Maybe<Scalars["String"]["output"]>;
};

/** A project */
export type Project = {
  candidates?: Maybe<Array<Maybe<Scalars["Int"]["output"]>>>;
  client_name?: Maybe<Scalars["String"]["output"]>;
  config?: Maybe<Scalars["JSON"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  is_demo?: Maybe<Scalars["Boolean"]["output"]>;
  kanban_columns?: Maybe<Array<Maybe<PositionKanbanStep>>>;
  meta?: Maybe<Scalars["JSON"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  objectives?: Maybe<Scalars["String"]["output"]>;
  org_id?: Maybe<Scalars["Int"]["output"]>;
  scorecard_id?: Maybe<Scalars["Int"]["output"]>;
  team_id?: Maybe<Scalars["Int"]["output"]>;
};

export type ProjectAccessLevel = "FULL" | "NONE" | "READ";

export type ProjectAssessmentRowInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  dimensions?: InputMaybe<Array<InputMaybe<AssessmentRowDimensionInput>>>;
  group_title?: InputMaybe<Scalars["String"]["input"]>;
  icon?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  order?: InputMaybe<Scalars["Int"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  type?: InputMaybe<Scalars["String"]["input"]>;
};

/** A note */
export type ProjectNote = {
  created_at?: Maybe<Scalars["String"]["output"]>;
  created_by?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  person_id?: Maybe<Scalars["Int"]["output"]>;
  project_id?: Maybe<Scalars["Int"]["output"]>;
  text?: Maybe<Scalars["String"]["output"]>;
  /** Default is 'note'. */
  type?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["String"]["output"]>;
};

export type ProjectRelationObjectInput = {
  access_level?: InputMaybe<ProjectAccessLevel>;
  id: Scalars["Int"]["input"];
  role?: InputMaybe<ProjectRoles>;
};

export type ProjectRoles = "CANDIDATE" | "COLLABORATOR";

export type ProjectsFilter = {
  org_id: Scalars["Int"]["input"];
  person_id?: InputMaybe<Scalars["Int"]["input"]>;
  team_id?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Redirect information */
export type RedirectType = {
  account_id?: Maybe<Scalars["Int"]["output"]>;
  url?: Maybe<Scalars["String"]["output"]>;
};

export type ResourceType = "ACCOUNT" | "ORGANIZATION" | "PROJECT" | "TEAM";

/** Root level for all database mutations */
export type RootMutation = {
  acceptInvite?: Maybe<AcceptInviteMutationResponse>;
  addPeople?: Maybe<MutationResponse>;
  archiveOrganization?: Maybe<MutationResponse>;
  assessmentLinkOrder?: Maybe<Scalars["String"]["output"]>;
  cloneProjectScorecardToWorkspace?: Maybe<MutationResponse>;
  completeOnboarding?: Maybe<Scalars["Boolean"]["output"]>;
  completeOnboardingStep?: Maybe<MutationResponse>;
  createAccount?: Maybe<MutationResponse>;
  createAssessment?: Maybe<Assessment>;
  createOrganization?: Maybe<OrganizationType>;
  createProject?: Maybe<Project>;
  createTask?: Maybe<MutationResponse>;
  createTeam?: Maybe<Team>;
  deleteAssessment?: Maybe<Assessment>;
  deleteCandidateAttachment?: Maybe<Scalars["Int"]["output"]>;
  deleteOrg?: Maybe<MutationResponse>;
  deletePersonNote?: Maybe<Scalars["Boolean"]["output"]>;
  deleteProject?: Maybe<Project>;
  deleteProjectAssessmentRow?: Maybe<MutationResponse>;
  deleteProjectAssessmentRows?: Maybe<MutationResponse>;
  deleteProjectNote?: Maybe<MutationResponse>;
  deleteScorecard?: Maybe<MutationResponse>;
  deleteScorecardRows?: Maybe<MutationResponse>;
  deleteTeam?: Maybe<MutationResponse>;
  deleteTeamNote?: Maybe<Scalars["Boolean"]["output"]>;
  deleteUserNote?: Maybe<Scalars["Boolean"]["output"]>;
  discardSurveyAnswers?: Maybe<MutationResponse>;
  evaluatePerson?: Maybe<AssessmentEvaluation>;
  finishAssessmentOrder?: Maybe<MutationResponse>;
  finishSurveyMutation?: Maybe<ActiveSurvey>;
  modifyTeam?: Maybe<Team>;
  removeAvatar?: Maybe<Viewer>;
  removePersonFromOrganization?: Maybe<MutationResponse>;
  removePersonFromPosition?: Maybe<MutationResponse>;
  removePersonFromTeam?: Maybe<MutationResponse>;
  removePersonFromWorkspace?: Maybe<MutationResponse>;
  reorderPositionKanban?: Maybe<MutationResponse>;
  resendInvite?: Maybe<MutationResponse>;
  saveSurveyAnswer?: Maybe<MutationResponse>;
  saveSurveyAnswers?: Maybe<MutationResponse>;
  sendContactInvite?: Maybe<MutationResponse>;
  sendProfileReminder?: Maybe<Scalars["Boolean"]["output"]>;
  setNewAccountOnboardingUsecase?: Maybe<Scalars["Boolean"]["output"]>;
  startFileEmbedding?: Maybe<Scalars["Boolean"]["output"]>;
  toggleGettingStarted?: Maybe<Viewer>;
  toggleShowPositionTour?: Maybe<Viewer>;
  toggleShowTeamTour?: Maybe<Viewer>;
  updateAccount?: Maybe<Account>;
  updateOrg?: Maybe<OrganizationType>;
  updatePassword?: Maybe<Viewer>;
  updateProject?: Maybe<MutationResponse>;
  updateUser?: Maybe<Viewer>;
  uploadAttachment?: Maybe<MutationResponse>;
  uploadAvatarMutation?: Maybe<Viewer>;
  upsertAssessmentNote?: Maybe<AssessmentNote>;
  upsertAssessmentSummary?: Maybe<MutationResponse>;
  upsertNote?: Maybe<Note>;
  /** This endpoint currently only supports updating existing person essential information. Person is not upserted when not found. */
  upsertPerson?: Maybe<MutationResponse>;
  /** This endpoint upserts an existing person role in the context of the organization, account or team. */
  upsertPersonAccessLevel?: Maybe<MutationResponse>;
  upsertPersonNote?: Maybe<PersonNoteType>;
  /** This endpoint upserts an existing person role in the context of the organization, account or team. */
  upsertPersonRole?: Maybe<MutationResponse>;
  upsertPersonScore?: Maybe<Dimension>;
  upsertPersonScoresBulk?: Maybe<MutationResponse>;
  upsertProjectAssessmentRows?: Maybe<MutationResponse>;
  upsertProjectNote?: Maybe<ProjectNote>;
  upsertScorecard?: Maybe<Scorecard>;
  upsertScorecardRows?: Maybe<MutationResponse>;
  upsertTeamNote?: Maybe<TeamNoteType>;
  upsertUserNote?: Maybe<UserNoteType>;
  /**
   *
   *     Validates multiple emails against people in the resource.
   *     For each email, if person exists, returns person object with roles list, otherwise returns an empty person record.
   *
   *     Response can be used to invite new people to the account or account resources (e.g., positions, teams, etc.) and/or
   *     validate the persons availability to add to resources.
   *
   */
  validatePeopleByEmail?: Maybe<ValidatePeopleResponse>;
  /**
   *
   *     Validates an email against people in the account.
   *     If person exists, returns person object with roles list, otherwise returns an empty person record.
   *
   *     Response can be used to invite new people to the account or account resources (e.g., positions, teams, etc.) and/or
   *     validate the persons availability to add to resources.
   *
   * @deprecated Use validatePeopleByEmail instead. This endpoint will be removed in the future.
   */
  validatePersonByEmail?: Maybe<ValidatePersonResponse>;
};

/** Root level for all database mutations */
export type RootMutationAcceptInviteArgs = {
  id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationAddPeopleArgs = {
  people?: InputMaybe<Array<InputMaybe<AddPersonInput>>>;
};

/** Root level for all database mutations */
export type RootMutationArchiveOrganizationArgs = {
  org_id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationAssessmentLinkOrderArgs = {
  assessmentType: Scalars["String"]["input"];
  redirectUrl: Scalars["String"]["input"];
};

/** Root level for all database mutations */
export type RootMutationCloneProjectScorecardToWorkspaceArgs = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  projectId: Scalars["Int"]["input"];
  title?: InputMaybe<Scalars["String"]["input"]>;
};

/** Root level for all database mutations */
export type RootMutationCompleteOnboardingStepArgs = {
  step: Scalars["String"]["input"];
};

/** Root level for all database mutations */
export type RootMutationCreateAccountArgs = {
  name: Scalars["String"]["input"];
};

/** Root level for all database mutations */
export type RootMutationCreateAssessmentArgs = {
  person_id: Scalars["Int"]["input"];
  project_id: Scalars["Int"]["input"];
  scorecard_id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationCreateOrganizationArgs = {
  account_id: Scalars["Int"]["input"];
  name: Scalars["String"]["input"];
};

/** Root level for all database mutations */
export type RootMutationCreateProjectArgs = {
  client_name?: InputMaybe<Scalars["String"]["input"]>;
  config?: InputMaybe<Scalars["JSONObject"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  objectives?: InputMaybe<Scalars["String"]["input"]>;
  org_id: Scalars["Int"]["input"];
  scorecard_id?: InputMaybe<Scalars["Int"]["input"]>;
  team_id?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Root level for all database mutations */
export type RootMutationCreateTaskArgs = {
  authorizedKeys?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  params?: InputMaybe<Scalars["JSONObject"]["input"]>;
  type: Scalars["String"]["input"];
};

/** Root level for all database mutations */
export type RootMutationCreateTeamArgs = {
  config?: InputMaybe<Scalars["JSONObject"]["input"]>;
  name: Scalars["String"]["input"];
  org_id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationDeleteAssessmentArgs = {
  assessment_id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationDeleteCandidateAttachmentArgs = {
  id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationDeleteOrgArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Root level for all database mutations */
export type RootMutationDeletePersonNoteArgs = {
  id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationDeleteProjectArgs = {
  id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationDeleteProjectAssessmentRowArgs = {
  id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationDeleteProjectAssessmentRowsArgs = {
  project_id: Scalars["Int"]["input"];
  rowIds: Array<InputMaybe<Scalars["Int"]["input"]>>;
};

/** Root level for all database mutations */
export type RootMutationDeleteProjectNoteArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Root level for all database mutations */
export type RootMutationDeleteScorecardArgs = {
  id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationDeleteScorecardRowsArgs = {
  row_ids?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  scorecard_id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationDeleteTeamArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Root level for all database mutations */
export type RootMutationDeleteTeamNoteArgs = {
  id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationDeleteUserNoteArgs = {
  id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationDiscardSurveyAnswersArgs = {
  assessment_order_id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationEvaluatePersonArgs = {
  assessment_id?: InputMaybe<Scalars["Int"]["input"]>;
  evaluation?: InputMaybe<Scalars["Int"]["input"]>;
  meta?: InputMaybe<Scalars["JSONObject"]["input"]>;
  person_id?: InputMaybe<Scalars["Int"]["input"]>;
  row_id?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Root level for all database mutations */
export type RootMutationFinishAssessmentOrderArgs = {
  assessment_order_id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationFinishSurveyMutationArgs = {
  answers?: InputMaybe<Array<InputMaybe<SurveyAnswerInputType>>>;
  survey_id?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Root level for all database mutations */
export type RootMutationModifyTeamArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>;
  name: Scalars["String"]["input"];
  org_id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationRemovePersonFromOrganizationArgs = {
  org_id?: InputMaybe<Scalars["Int"]["input"]>;
  person_id?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Root level for all database mutations */
export type RootMutationRemovePersonFromPositionArgs = {
  keep_access?: InputMaybe<Scalars["Boolean"]["input"]>;
  person_id: Scalars["Int"]["input"];
  position_id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationRemovePersonFromTeamArgs = {
  person_id: Scalars["Int"]["input"];
  team_id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationRemovePersonFromWorkspaceArgs = {
  person_id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationReorderPositionKanbanArgs = {
  column_id: Scalars["Int"]["input"];
  order: Scalars["Int"]["input"];
  person_id: Scalars["Int"]["input"];
  position_id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationResendInviteArgs = {
  person_id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationSaveSurveyAnswerArgs = {
  answer: Scalars["Int"]["input"];
  assessment_order_id: Scalars["Int"]["input"];
  duration_ms?: InputMaybe<Scalars["Int"]["input"]>;
  question_dim_id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationSaveSurveyAnswersArgs = {
  answers: Array<AssessmentSurveyAnswerInput>;
  assessment_order_id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationSendContactInviteArgs = {
  person_id: Scalars["Int"]["input"];
  project_id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationSendProfileReminderArgs = {
  person_id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationSetNewAccountOnboardingUsecaseArgs = {
  usecase: Scalars["String"]["input"];
};

/** Root level for all database mutations */
export type RootMutationStartFileEmbeddingArgs = {
  file_id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationUpdateAccountArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
};

/** Root level for all database mutations */
export type RootMutationUpdateOrgArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
};

/** Root level for all database mutations */
export type RootMutationUpdatePasswordArgs = {
  new_password: Scalars["String"]["input"];
  old_password: Scalars["String"]["input"];
  repeat_new_password: Scalars["String"]["input"];
};

/** Root level for all database mutations */
export type RootMutationUpdateProjectArgs = {
  client_name?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
  name?: InputMaybe<Scalars["String"]["input"]>;
  objectives?: InputMaybe<Scalars["String"]["input"]>;
  scorecard_id?: InputMaybe<Scalars["Int"]["input"]>;
  team_id?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Root level for all database mutations */
export type RootMutationUpdateUserArgs = {
  companySize?: InputMaybe<Scalars["String"]["input"]>;
  first_name?: InputMaybe<Scalars["String"]["input"]>;
  last_name?: InputMaybe<Scalars["String"]["input"]>;
  linkedIn?: InputMaybe<Scalars["String"]["input"]>;
  occupation?: InputMaybe<Scalars["String"]["input"]>;
  phone?: InputMaybe<Scalars["String"]["input"]>;
};

/** Root level for all database mutations */
export type RootMutationUploadAttachmentArgs = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  file?: InputMaybe<Scalars["Upload"]["input"]>;
  person_id?: InputMaybe<Scalars["Int"]["input"]>;
  project_id: Scalars["Int"]["input"];
  size: Scalars["Int"]["input"];
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** Root level for all database mutations */
export type RootMutationUploadAvatarMutationArgs = {
  image?: InputMaybe<Scalars["Upload"]["input"]>;
};

/** Root level for all database mutations */
export type RootMutationUpsertAssessmentNoteArgs = {
  assessment_id: Scalars["Int"]["input"];
  id?: InputMaybe<Scalars["Int"]["input"]>;
  person_id?: InputMaybe<Scalars["Int"]["input"]>;
  row_id?: InputMaybe<Scalars["Int"]["input"]>;
  text: Scalars["String"]["input"];
  type: Scalars["String"]["input"];
};

/** Root level for all database mutations */
export type RootMutationUpsertAssessmentSummaryArgs = {
  assessment_id: Scalars["Int"]["input"];
  summary?: InputMaybe<Scalars["String"]["input"]>;
};

/** Root level for all database mutations */
export type RootMutationUpsertNoteArgs = {
  assessment_id?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  person_id?: InputMaybe<Scalars["Int"]["input"]>;
  position_id?: InputMaybe<Scalars["Int"]["input"]>;
  row_id?: InputMaybe<Scalars["Int"]["input"]>;
  team_id?: InputMaybe<Scalars["Int"]["input"]>;
  text?: InputMaybe<Scalars["String"]["input"]>;
  type: Scalars["String"]["input"];
  user_id?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Root level for all database mutations */
export type RootMutationUpsertPersonArgs = {
  email?: InputMaybe<Scalars["String"]["input"]>;
  first_name?: InputMaybe<Scalars["String"]["input"]>;
  last_name?: InputMaybe<Scalars["String"]["input"]>;
  linkedin?: InputMaybe<Scalars["String"]["input"]>;
  person_id: Scalars["Int"]["input"];
  phone?: InputMaybe<Scalars["String"]["input"]>;
};

/** Root level for all database mutations */
export type RootMutationUpsertPersonAccessLevelArgs = {
  access_level: Scalars["String"]["input"];
  id: Scalars["Int"]["input"];
  person_id: Scalars["Int"]["input"];
  type: Scalars["String"]["input"];
};

/** Root level for all database mutations */
export type RootMutationUpsertPersonNoteArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>;
  note: Scalars["String"]["input"];
  person_id: Scalars["Int"]["input"];
  type: Scalars["String"]["input"];
};

/** Root level for all database mutations */
export type RootMutationUpsertPersonRoleArgs = {
  id: Scalars["Int"]["input"];
  person_id: Scalars["Int"]["input"];
  role: Scalars["String"]["input"];
  type: Scalars["String"]["input"];
};

/** Root level for all database mutations */
export type RootMutationUpsertPersonScoreArgs = {
  dim_id: Scalars["Int"]["input"];
  person_id: Scalars["Int"]["input"];
  score: Scalars["Float"]["input"];
};

/** Root level for all database mutations */
export type RootMutationUpsertPersonScoresBulkArgs = {
  person_id: Scalars["Int"]["input"];
  scores: Array<InputMaybe<ScoreInput>>;
};

/** Root level for all database mutations */
export type RootMutationUpsertProjectAssessmentRowsArgs = {
  project_id: Scalars["Int"]["input"];
  rows?: InputMaybe<Array<InputMaybe<ProjectAssessmentRowInput>>>;
};

/** Root level for all database mutations */
export type RootMutationUpsertProjectNoteArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>;
  person_id?: InputMaybe<Scalars["Int"]["input"]>;
  project_id?: InputMaybe<Scalars["Int"]["input"]>;
  text?: InputMaybe<Scalars["String"]["input"]>;
  type: Scalars["String"]["input"];
};

/** Root level for all database mutations */
export type RootMutationUpsertScorecardArgs = {
  category_id?: InputMaybe<Scalars["Int"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  project_id?: InputMaybe<Scalars["Int"]["input"]>;
  tag_id?: InputMaybe<Scalars["Int"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

/** Root level for all database mutations */
export type RootMutationUpsertScorecardRowsArgs = {
  rows?: InputMaybe<Array<InputMaybe<ProjectAssessmentRowInput>>>;
  scorecard_id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationUpsertTeamNoteArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>;
  note: Scalars["String"]["input"];
  person_id?: InputMaybe<Scalars["Int"]["input"]>;
  team_id: Scalars["Int"]["input"];
  type: Scalars["String"]["input"];
};

/** Root level for all database mutations */
export type RootMutationUpsertUserNoteArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>;
  note: Scalars["String"]["input"];
  type: Scalars["String"]["input"];
};

/** Root level for all database mutations */
export type RootMutationValidatePeopleByEmailArgs = {
  emails?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  resource?: InputMaybe<ResourceType>;
  resourceId?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Root level for all database mutations */
export type RootMutationValidatePersonByEmailArgs = {
  email?: InputMaybe<Scalars["String"]["input"]>;
};

/** Root query */
export type RootQuery = {
  account?: Maybe<Account>;
  accounts?: Maybe<Array<Maybe<Account>>>;
  assessment?: Maybe<Assessment>;
  assessmentOrder?: Maybe<AssessmentOrder>;
  assessmentOrderCompletion?: Maybe<AssessmentOrder>;
  assessments?: Maybe<Array<Maybe<Assessment>>>;
  attachmentReadSignedUrl?: Maybe<Scalars["String"]["output"]>;
  attachments?: Maybe<Array<Maybe<Attachment>>>;
  authorizedPerson?: Maybe<Person>;
  dictionary?: Maybe<Array<Maybe<DimText>>>;
  dimensions?: Maybe<Array<Maybe<Dimension>>>;
  evaluations?: Maybe<Array<Maybe<AssessmentEvaluation>>>;
  notes?: Maybe<Array<Maybe<Note>>>;
  notifications?: Maybe<Array<Maybe<Notification>>>;
  organization?: Maybe<OrganizationType>;
  organizations?: Maybe<Array<Maybe<OrganizationType>>>;
  people?: Maybe<Array<Maybe<Person>>>;
  person?: Maybe<Person>;
  personNotes?: Maybe<Array<Maybe<PersonNoteType>>>;
  project?: Maybe<Project>;
  projectNotes?: Maybe<Array<Maybe<ProjectNote>>>;
  projects?: Maybe<Array<Maybe<Project>>>;
  scorecard?: Maybe<Scorecard>;
  scorecardTagsAndCategories?: Maybe<ScorecardTagAndCategory>;
  scorecards?: Maybe<Array<Maybe<Scorecard>>>;
  shareCandidateProfile?: Maybe<Scalars["String"]["output"]>;
  survey?: Maybe<ActiveSurvey>;
  surveys?: Maybe<Array<Maybe<AssessmentSurvey>>>;
  team?: Maybe<Team>;
  teamNotes?: Maybe<Array<Maybe<TeamNoteType>>>;
  teams?: Maybe<Array<Maybe<Team>>>;
  userNotes?: Maybe<Array<Maybe<UserNoteType>>>;
  viewer?: Maybe<Viewer>;
  wisgptContextToken?: Maybe<Scalars["String"]["output"]>;
};

/** Root query */
export type RootQueryAccountArgs = {
  id: Scalars["Int"]["input"];
};

/** Root query */
export type RootQueryAssessmentArgs = {
  id: Scalars["Int"]["input"];
};

/** Root query */
export type RootQueryAssessmentOrderArgs = {
  id: Scalars["Int"]["input"];
};

/** Root query */
export type RootQueryAssessmentOrderCompletionArgs = {
  id: Scalars["Int"]["input"];
};

/** Root query */
export type RootQueryAssessmentsArgs = {
  person_id?: InputMaybe<Scalars["Int"]["input"]>;
  project_id?: InputMaybe<Scalars["Int"]["input"]>;
  scorecard_id?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Root query */
export type RootQueryAttachmentReadSignedUrlArgs = {
  id: Scalars["Int"]["input"];
};

/** Root query */
export type RootQueryAttachmentsArgs = {
  filter?: InputMaybe<AttachmentsFilter>;
};

/** Root query */
export type RootQueryDimensionsArgs = {
  filter?: InputMaybe<DimensionsFilter>;
};

/** Root query */
export type RootQueryEvaluationsArgs = {
  assessment_id?: InputMaybe<Scalars["Int"]["input"]>;
  person_id?: InputMaybe<Scalars["Int"]["input"]>;
  project_id?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Root query */
export type RootQueryNotesArgs = {
  filter?: InputMaybe<NotesFilter>;
  person_id?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Root query */
export type RootQueryOrganizationArgs = {
  id: Scalars["Int"]["input"];
};

/** Root query */
export type RootQueryOrganizationsArgs = {
  account_id: Scalars["Int"]["input"];
};

/** Root query */
export type RootQueryPeopleArgs = {
  filter?: InputMaybe<PeopleFilter>;
};

/** Root query */
export type RootQueryPersonArgs = {
  id: Scalars["Int"]["input"];
};

/** Root query */
export type RootQueryPersonNotesArgs = {
  filter?: InputMaybe<PersonNotesFilter>;
};

/** Root query */
export type RootQueryProjectArgs = {
  id: Scalars["Int"]["input"];
};

/** Root query */
export type RootQueryProjectNotesArgs = {
  person_id: Scalars["Int"]["input"];
  project_id: Scalars["Int"]["input"];
  type?: InputMaybe<Scalars["String"]["input"]>;
};

/** Root query */
export type RootQueryProjectsArgs = {
  filter: ProjectsFilter;
};

/** Root query */
export type RootQueryScorecardArgs = {
  id: Scalars["Int"]["input"];
};

/** Root query */
export type RootQueryScorecardsArgs = {
  scorecard_ids?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
};

/** Root query */
export type RootQueryShareCandidateProfileArgs = {
  org_id: Scalars["Int"]["input"];
  person_id: Scalars["Int"]["input"];
  project_id: Scalars["Int"]["input"];
};

/** Root query */
export type RootQuerySurveyArgs = {
  id: Scalars["Int"]["input"];
};

/** Root query */
export type RootQueryTeamArgs = {
  id: Scalars["Int"]["input"];
};

/** Root query */
export type RootQueryTeamNotesArgs = {
  filter?: InputMaybe<TeamNotesFilter>;
};

/** Root query */
export type RootQueryTeamsArgs = {
  filter: TeamsFilter;
};

/** Root query */
export type RootQueryUserNotesArgs = {
  filter?: InputMaybe<UserNotesFilter>;
};

/** Root query */
export type RootQueryWisgptContextTokenArgs = {
  assessment_id?: InputMaybe<Scalars["Int"]["input"]>;
  org_id?: InputMaybe<Scalars["Int"]["input"]>;
  person_id?: InputMaybe<Scalars["Int"]["input"]>;
  position_id?: InputMaybe<Scalars["Int"]["input"]>;
  project_id?: InputMaybe<Scalars["Int"]["input"]>;
  scorecard_id?: InputMaybe<Scalars["Int"]["input"]>;
  survey_config?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  team_id?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A score */
export type Score = {
  key?: Maybe<Scalars["String"]["output"]>;
  obj_id?: Maybe<Scalars["Int"]["output"]>;
  obj_type?: Maybe<Scalars["String"]["output"]>;
  value?: Maybe<Scalars["Float"]["output"]>;
};

export type ScoreInput = {
  dim_id: Scalars["Int"]["input"];
  score: Scalars["Float"]["input"];
};

/** Assessment scorecard */
export type Scorecard = {
  category?: Maybe<ScorecardCategory>;
  created_at?: Maybe<Scalars["Date"]["output"]>;
  created_by?: Maybe<Scalars["Int"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  is_global?: Maybe<Scalars["Boolean"]["output"]>;
  meta?: Maybe<Scalars["JSONObject"]["output"]>;
  objectives?: Maybe<Scalars["String"]["output"]>;
  project_id?: Maybe<Scalars["Int"]["output"]>;
  rows?: Maybe<Array<Maybe<ScorecardRow>>>;
  tag?: Maybe<ScorecardTag>;
  title?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
};

/** Scorecard category */
export type ScorecardCategory = {
  color?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
};

export type ScorecardRow = {
  color?: Maybe<Scalars["String"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  dimensions?: Maybe<Array<Maybe<ScorecardRowDimension>>>;
  example_prompts?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  group_title?: Maybe<Scalars["String"]["output"]>;
  icon?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  meta?: Maybe<Scalars["JSONObject"]["output"]>;
  order?: Maybe<Scalars["Int"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
  type?: Maybe<Scalars["String"]["output"]>;
};

export type ScorecardRowDimension = {
  dim_id?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  target_max?: Maybe<Scalars["Int"]["output"]>;
  target_min?: Maybe<Scalars["Int"]["output"]>;
};

/** Tag for scorecard */
export type ScorecardTag = {
  id?: Maybe<Scalars["Int"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
};

export type ScorecardTagAndCategory = {
  categories?: Maybe<Array<Maybe<ScorecardCategory>>>;
  tags?: Maybe<Array<Maybe<ScorecardTag>>>;
};

/** A profile summary */
export type Summary = {
  text?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
};

export type Survey = {
  assessment_type?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  intro?: Maybe<Scalars["JSONObject"]["output"]>;
  rows?: Maybe<Array<Maybe<AssessmentSurveyRow>>>;
  ui?: Maybe<Scalars["String"]["output"]>;
};

export type SurveyAnswerInputType = {
  answer?: InputMaybe<Scalars["Int"]["input"]>;
  duration_ms?: InputMaybe<Scalars["Int"]["input"]>;
  obj_id?: InputMaybe<Scalars["Int"]["input"]>;
  obj_type_id?: InputMaybe<Scalars["Int"]["input"]>;
  question_dim_id?: InputMaybe<Scalars["Int"]["input"]>;
  subject_id?: InputMaybe<Scalars["Int"]["input"]>;
  subject_type_id?: InputMaybe<Scalars["Int"]["input"]>;
  survey_row_id?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Survey answer object */
export type SurveyAnswerObject = {
  answer?: Maybe<Scalars["Int"]["output"]>;
  duration_ms?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  obj_type_id?: Maybe<Scalars["Int"]["output"]>;
  question_dim_id?: Maybe<Scalars["Int"]["output"]>;
  subject_id?: Maybe<Scalars["Int"]["output"]>;
  subject_type_id?: Maybe<Scalars["Int"]["output"]>;
  survey_row_id?: Maybe<Scalars["Int"]["output"]>;
};

/** A survey completion */
export type SurveyCompletion = {
  completed?: Maybe<Scalars["Boolean"]["output"]>;
  survey_id?: Maybe<Scalars["Int"]["output"]>;
  survey_type?: Maybe<Scalars["String"]["output"]>;
  text_id?: Maybe<Scalars["String"]["output"]>;
};

/** The survey row with dimension */
export type SurveyRowLoaded = {
  dimension?: Maybe<DimensionLoaded>;
  external_trait_id?: Maybe<Scalars["Int"]["output"]>;
  question_dim_id?: Maybe<Scalars["Int"]["output"]>;
  row_block_id?: Maybe<Scalars["Int"]["output"]>;
  row_id?: Maybe<Scalars["Int"]["output"]>;
  survey_id?: Maybe<Scalars["Int"]["output"]>;
  survey_row_id?: Maybe<Scalars["Int"]["output"]>;
};

/** A Team */
export type Team = {
  admin_rights?: Maybe<Scalars["Boolean"]["output"]>;
  config?: Maybe<Scalars["JSON"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  is_demo?: Maybe<Scalars["Boolean"]["output"]>;
  members?: Maybe<Array<Maybe<Scalars["Int"]["output"]>>>;
  name?: Maybe<Scalars["String"]["output"]>;
  org_id?: Maybe<Scalars["Int"]["output"]>;
};

export type TeamAccessLevel = "FULL" | "NONE" | "READ";

/** A team note */
export type TeamNoteType = {
  created_at?: Maybe<Scalars["Date"]["output"]>;
  created_by?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  note?: Maybe<Scalars["String"]["output"]>;
  person_id?: Maybe<Scalars["Int"]["output"]>;
  team_id?: Maybe<Scalars["Int"]["output"]>;
  type?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
};

export type TeamNotesFilter = {
  person_id?: InputMaybe<Scalars["Int"]["input"]>;
  team_id?: InputMaybe<Scalars["Int"]["input"]>;
  type?: InputMaybe<Scalars["String"]["input"]>;
};

export type TeamRelationObjectInput = {
  access_level?: InputMaybe<TeamAccessLevel>;
  id: Scalars["Int"]["input"];
  role?: InputMaybe<TeamRoles>;
};

export type TeamRoles = "COLLABORATOR" | "MEMBER";

export type TeamsFilter = {
  org_id: Scalars["Int"]["input"];
  person_id?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A user note */
export type UserNoteType = {
  created_at?: Maybe<Scalars["Date"]["output"]>;
  created_by?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  note?: Maybe<Scalars["String"]["output"]>;
  type?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  user_id?: Maybe<Scalars["Int"]["output"]>;
};

export type UserNotesFilter = {
  type?: InputMaybe<Scalars["String"]["input"]>;
};

/** User onboarding information */
export type UserOnboarding = {
  completed_at?: Maybe<Scalars["Date"]["output"]>;
  skipped_at?: Maybe<Scalars["Date"]["output"]>;
  steps?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  type?: Maybe<Scalars["String"]["output"]>;
};

/** Bulk person validation response */
export type ValidatePeopleResponse = {
  people?: Maybe<Array<Maybe<Person>>>;
};

/** Person validation response */
export type ValidatePersonResponse = {
  person?: Maybe<Person>;
};

/** The viewer who has logged in. */
export type Viewer = {
  avatar_url?: Maybe<Scalars["String"]["output"]>;
  birthday?: Maybe<Scalars["String"]["output"]>;
  default_account_id?: Maybe<Scalars["Int"]["output"]>;
  default_organization_id?: Maybe<Scalars["Int"]["output"]>;
  email?: Maybe<Scalars["String"]["output"]>;
  first_name?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated This field is deprecated and will be removed in a future version. This just returns null */
  has_password_login?: Maybe<Scalars["Boolean"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  initials?: Maybe<Scalars["String"]["output"]>;
  last_name?: Maybe<Scalars["String"]["output"]>;
  linkedIn?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  occupation?: Maybe<Scalars["String"]["output"]>;
  onboarding?: Maybe<UserOnboarding>;
  phone?: Maybe<Scalars["String"]["output"]>;
  showGettingStarted?: Maybe<Scalars["Boolean"]["output"]>;
  showPositionTour?: Maybe<Scalars["Boolean"]["output"]>;
  showTeamTour?: Maybe<Scalars["Boolean"]["output"]>;
  survey_completion?: Maybe<Array<Maybe<SurveyCompletion>>>;
  /** @deprecated This field is deprecated and will be removed in a future version. Use survey_completion instead. This just returns null */
  surveys?: Maybe<Array<Maybe<ActiveSurvey>>>;
  type?: Maybe<Scalars["String"]["output"]>;
};

export type WorkspaceAccessLevel = "EDIT" | "FULL" | "LIMITED" | "NONE";

export type WorkspaceRoles =
  | "ADMIN"
  | "CANDIDATE"
  | "CONTACT"
  | "MEMBER"
  | "OWNER";

export type AddPeopleMutationVariables = Exact<{
  people?: InputMaybe<
    Array<InputMaybe<AddPersonInput>> | InputMaybe<AddPersonInput>
  >;
}>;

export type AddPeopleMutation = {
  __typename: "RootMutation";
  addPeople?:
    | {
        __typename: "MutationResponse";
        message?: string | null | undefined;
        success?: boolean | null | undefined;
      }
    | null
    | undefined;
};

export type EvaluatePersonMutationVariables = Exact<{
  personId?: InputMaybe<Scalars["Int"]["input"]>;
  rowId?: InputMaybe<Scalars["Int"]["input"]>;
  assessmentId?: InputMaybe<Scalars["Int"]["input"]>;
  evaluation?: InputMaybe<Scalars["Int"]["input"]>;
  meta?: InputMaybe<Scalars["JSONObject"]["input"]>;
}>;

export type EvaluatePersonMutation = {
  __typename: "RootMutation";
  evaluatePerson?:
    | {
        __typename: "AssessmentEvaluation";
        id?: number | null | undefined;
        row_id?: number | null | undefined;
        person_id?: number | null | undefined;
        evaluation?: number | null | undefined;
        created_at?: string | null | undefined;
        created_by?: number | null | undefined;
        meta?: Record<string, any> | null | undefined;
      }
    | null
    | undefined;
};

export type RemovePersonFromOrganizationMutationVariables = Exact<{
  orgId?: InputMaybe<Scalars["Int"]["input"]>;
  personId?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type RemovePersonFromOrganizationMutation = {
  __typename: "RootMutation";
  removePersonFromOrganization?:
    | {
        __typename: "MutationResponse";
        message?: string | null | undefined;
        success?: boolean | null | undefined;
      }
    | null
    | undefined;
};

export type RemovePersonFromWorkspaceMutationVariables = Exact<{
  personId: Scalars["Int"]["input"];
}>;

export type RemovePersonFromWorkspaceMutation = {
  __typename: "RootMutation";
  removePersonFromWorkspace?:
    | {
        __typename: "MutationResponse";
        ids?: Array<number | null | undefined> | null | undefined;
        message?: string | null | undefined;
        success?: boolean | null | undefined;
      }
    | null
    | undefined;
};

export type ResendInviteMutationVariables = Exact<{
  personId: Scalars["Int"]["input"];
}>;

export type ResendInviteMutation = {
  __typename: "RootMutation";
  resendInvite?:
    | {
        __typename: "MutationResponse";
        message?: string | null | undefined;
        success?: boolean | null | undefined;
      }
    | null
    | undefined;
};

export type SendContactInviteMutationVariables = Exact<{
  projectId: Scalars["Int"]["input"];
  personId: Scalars["Int"]["input"];
}>;

export type SendContactInviteMutation = {
  __typename: "RootMutation";
  sendContactInvite?:
    | {
        __typename: "MutationResponse";
        message?: string | null | undefined;
        success?: boolean | null | undefined;
      }
    | null
    | undefined;
};

export type SendProfileReminderMutationVariables = Exact<{
  personId: Scalars["Int"]["input"];
}>;

export type SendProfileReminderMutation = {
  __typename: "RootMutation";
  sendProfileReminder?: boolean | null | undefined;
};

export type UpsertPersonScoreMutationVariables = Exact<{
  dimId: Scalars["Int"]["input"];
  score: Scalars["Float"]["input"];
  personId: Scalars["Int"]["input"];
}>;

export type UpsertPersonScoreMutation = {
  __typename: "RootMutation";
  upsertPersonScore?:
    | {
        __typename: "Dimension";
        dim_id?: number | null | undefined;
        code?: string | null | undefined;
        group?: string | null | undefined;
        group_title?: string | null | undefined;
        parent?: string | null | undefined;
        parent_id?: number | null | undefined;
        parent_title?: string | null | undefined;
        scores?:
          | Array<
              | {
                  __typename: "Score";
                  obj_type?: string | null | undefined;
                  obj_id?: number | null | undefined;
                  key?: string | null | undefined;
                  value?: number | null | undefined;
                }
              | null
              | undefined
            >
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type UpsertPersonMutationVariables = Exact<{
  personId: Scalars["Int"]["input"];
  email?: InputMaybe<Scalars["String"]["input"]>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  phone?: InputMaybe<Scalars["String"]["input"]>;
  linkedin?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type UpsertPersonMutation = {
  __typename: "RootMutation";
  upsertPerson?:
    | {
        __typename: "MutationResponse";
        message?: string | null | undefined;
        success?: boolean | null | undefined;
      }
    | null
    | undefined;
};

export type UpsertPersonAccessLevelMutationVariables = Exact<{
  personId: Scalars["Int"]["input"];
  type: Scalars["String"]["input"];
  access_level: Scalars["String"]["input"];
  objectId: Scalars["Int"]["input"];
}>;

export type UpsertPersonAccessLevelMutation = {
  __typename: "RootMutation";
  upsertPersonAccessLevel?:
    | {
        __typename: "MutationResponse";
        message?: string | null | undefined;
        success?: boolean | null | undefined;
      }
    | null
    | undefined;
};

export type UpsertPersonNoteMutationVariables = Exact<{
  personId: Scalars["Int"]["input"];
  note: Scalars["String"]["input"];
  type: Scalars["String"]["input"];
  id?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type UpsertPersonNoteMutation = {
  __typename: "RootMutation";
  upsertPersonNote?:
    | {
        __typename: "PersonNoteType";
        id?: number | null | undefined;
        person_id?: number | null | undefined;
        note?: string | null | undefined;
        type?: string | null | undefined;
        created_by?: number | null | undefined;
        updated_at?: string | null | undefined;
        created_at?: string | null | undefined;
      }
    | null
    | undefined;
};

export type UpsertPersonRoleMutationVariables = Exact<{
  personId: Scalars["Int"]["input"];
  type: Scalars["String"]["input"];
  role: Scalars["String"]["input"];
  objectId: Scalars["Int"]["input"];
}>;

export type UpsertPersonRoleMutation = {
  __typename: "RootMutation";
  upsertPersonRole?:
    | {
        __typename: "MutationResponse";
        message?: string | null | undefined;
        success?: boolean | null | undefined;
      }
    | null
    | undefined;
};

export type UpsertPersonScoresBulkMutationVariables = Exact<{
  personId: Scalars["Int"]["input"];
  scores: Array<InputMaybe<ScoreInput>> | InputMaybe<ScoreInput>;
}>;

export type UpsertPersonScoresBulkMutation = {
  __typename: "RootMutation";
  upsertPersonScoresBulk?:
    | {
        __typename: "MutationResponse";
        message?: string | null | undefined;
        success?: boolean | null | undefined;
      }
    | null
    | undefined;
};

export type ValidatePeopleByEmailMutationVariables = Exact<{
  emails?: InputMaybe<
    | Array<InputMaybe<Scalars["String"]["input"]>>
    | InputMaybe<Scalars["String"]["input"]>
  >;
  resource?: InputMaybe<ResourceType>;
  resourceId?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type ValidatePeopleByEmailMutation = {
  __typename: "RootMutation";
  validatePeopleByEmail?:
    | {
        __typename: "ValidatePeopleResponse";
        people?:
          | Array<
              | {
                  __typename: "Person";
                  id?: number | null | undefined;
                  first_name?: string | null | undefined;
                  last_name?: string | null | undefined;
                  name?: string | null | undefined;
                  email?: string | null | undefined;
                  avatar?: string | null | undefined;
                  initials?: string | null | undefined;
                  linkedin?: string | null | undefined;
                  phone?: string | null | undefined;
                  is_contact?: boolean | null | undefined;
                  invite?:
                    | {
                        __typename: "PersonInvite";
                        created_at?: string | null | undefined;
                        secret?: string | null | undefined;
                      }
                    | null
                    | undefined;
                  roles?:
                    | Array<
                        | {
                            __typename: "PersonRole";
                            id?: string | null | undefined;
                            obj_id?: number | null | undefined;
                            role?: string | null | undefined;
                            type?: string | null | undefined;
                            access_level?: string | null | undefined;
                            person_id?: number | null | undefined;
                          }
                        | null
                        | undefined
                      >
                    | null
                    | undefined;
                  survey_completion?:
                    | Array<
                        | {
                            __typename: "SurveyCompletion";
                            survey_id?: number | null | undefined;
                            survey_type?: string | null | undefined;
                            text_id?: string | null | undefined;
                            completed?: boolean | null | undefined;
                          }
                        | null
                        | undefined
                      >
                    | null
                    | undefined;
                }
              | null
              | undefined
            >
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type ValidatePersonByEmailMutationVariables = Exact<{
  email?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type ValidatePersonByEmailMutation = {
  __typename: "RootMutation";
  validatePersonByEmail?:
    | {
        __typename: "ValidatePersonResponse";
        person?:
          | {
              __typename: "Person";
              email?: string | null | undefined;
              id?: number | null | undefined;
              first_name?: string | null | undefined;
              last_name?: string | null | undefined;
              name?: string | null | undefined;
              avatar?: string | null | undefined;
              roles?:
                | Array<
                    | {
                        __typename: "PersonRole";
                        id?: string | null | undefined;
                        obj_id?: number | null | undefined;
                        role?: string | null | undefined;
                        type?: string | null | undefined;
                        access_level?: string | null | undefined;
                        person_id?: number | null | undefined;
                      }
                    | null
                    | undefined
                  >
                | null
                | undefined;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type EvaluationsQueryVariables = Exact<{
  personId?: InputMaybe<Scalars["Int"]["input"]>;
  projectId?: InputMaybe<Scalars["Int"]["input"]>;
  assessmentId?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type EvaluationsQuery = {
  __typename: "RootQuery";
  evaluations?:
    | Array<
        | {
            __typename: "AssessmentEvaluation";
            id?: number | null | undefined;
            row_id?: number | null | undefined;
            person_id?: number | null | undefined;
            evaluation?: number | null | undefined;
            created_at?: string | null | undefined;
            created_by?: number | null | undefined;
            meta?: Record<string, any> | null | undefined;
          }
        | null
        | undefined
      >
    | null
    | undefined;
};

export type PeopleQueryVariables = Exact<{
  filter?: InputMaybe<PeopleFilter>;
}>;

export type PeopleQuery = {
  __typename: "RootQuery";
  people?:
    | Array<
        | {
            __typename: "Person";
            id?: number | null | undefined;
            first_name?: string | null | undefined;
            last_name?: string | null | undefined;
            name?: string | null | undefined;
            email?: string | null | undefined;
            avatar?: string | null | undefined;
            initials?: string | null | undefined;
            linkedin?: string | null | undefined;
            phone?: string | null | undefined;
            is_contact?: boolean | null | undefined;
            completed_dim_types?:
              | Array<string | null | undefined>
              | null
              | undefined;
            invite?:
              | {
                  __typename: "PersonInvite";
                  created_at?: string | null | undefined;
                  secret?: string | null | undefined;
                }
              | null
              | undefined;
            roles?:
              | Array<
                  | {
                      __typename: "PersonRole";
                      id?: string | null | undefined;
                      obj_id?: number | null | undefined;
                      role?: string | null | undefined;
                      type?: string | null | undefined;
                      access_level?: string | null | undefined;
                      person_id?: number | null | undefined;
                    }
                  | null
                  | undefined
                >
              | null
              | undefined;
            survey_completion?:
              | Array<
                  | {
                      __typename: "SurveyCompletion";
                      survey_id?: number | null | undefined;
                      survey_type?: string | null | undefined;
                      text_id?: string | null | undefined;
                      completed?: boolean | null | undefined;
                    }
                  | null
                  | undefined
                >
              | null
              | undefined;
          }
        | null
        | undefined
      >
    | null
    | undefined;
};

export type PersonQueryVariables = Exact<{
  personId: Scalars["Int"]["input"];
}>;

export type PersonQuery = {
  __typename: "RootQuery";
  person?:
    | {
        __typename: "Person";
        id?: number | null | undefined;
        first_name?: string | null | undefined;
        last_name?: string | null | undefined;
        name?: string | null | undefined;
        email?: string | null | undefined;
        avatar?: string | null | undefined;
        initials?: string | null | undefined;
        linkedin?: string | null | undefined;
        phone?: string | null | undefined;
        is_contact?: boolean | null | undefined;
        completed_dim_types?:
          | Array<string | null | undefined>
          | null
          | undefined;
        invite?:
          | {
              __typename: "PersonInvite";
              created_at?: string | null | undefined;
              secret?: string | null | undefined;
            }
          | null
          | undefined;
        roles?:
          | Array<
              | {
                  __typename: "PersonRole";
                  id?: string | null | undefined;
                  obj_id?: number | null | undefined;
                  role?: string | null | undefined;
                  type?: string | null | undefined;
                  access_level?: string | null | undefined;
                  person_id?: number | null | undefined;
                }
              | null
              | undefined
            >
          | null
          | undefined;
        survey_completion?:
          | Array<
              | {
                  __typename: "SurveyCompletion";
                  survey_id?: number | null | undefined;
                  survey_type?: string | null | undefined;
                  text_id?: string | null | undefined;
                  completed?: boolean | null | undefined;
                }
              | null
              | undefined
            >
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type PersonNotesQueryVariables = Exact<{
  filter?: InputMaybe<PersonNotesFilter>;
}>;

export type PersonNotesQuery = {
  __typename: "RootQuery";
  personNotes?:
    | Array<
        | {
            __typename: "PersonNoteType";
            id?: number | null | undefined;
            person_id?: number | null | undefined;
            note?: string | null | undefined;
            type?: string | null | undefined;
            created_by?: number | null | undefined;
            updated_at?: string | null | undefined;
            created_at?: string | null | undefined;
          }
        | null
        | undefined
      >
    | null
    | undefined;
};

export type ShareCandidateProfileQueryVariables = Exact<{
  personId: Scalars["Int"]["input"];
  projectId: Scalars["Int"]["input"];
  orgId: Scalars["Int"]["input"];
}>;

export type ShareCandidateProfileQuery = {
  __typename: "RootQuery";
  shareCandidateProfile?: string | null | undefined;
};

export type RoleFieldsFragment = {
  __typename: "PersonRole";
  id?: string | null | undefined;
  obj_id?: number | null | undefined;
  role?: string | null | undefined;
  type?: string | null | undefined;
  access_level?: string | null | undefined;
  person_id?: number | null | undefined;
  actions?: Array<string | null | undefined> | null | undefined;
  administration?:
    | {
        __typename: "PermissionAdministration";
        id?: string | null | undefined;
        can_change_access_level?: boolean | null | undefined;
        can_change_role?: boolean | null | undefined;
        can_invite?: boolean | null | undefined;
        can_revoke?: boolean | null | undefined;
        max_grant_role?: string | null | undefined;
        max_grant_access_level?: string | null | undefined;
        grantable_roles?: Array<string | null | undefined> | null | undefined;
        grantable_access_levels?:
          | Array<string | null | undefined>
          | null
          | undefined;
        constraints?:
          | {
              __typename: "PermissionAdministrationConstraints";
              organization_full_implies_admin?: boolean | null | undefined;
              workspace_admin_edit_no_manage_people?:
                | boolean
                | null
                | undefined;
              notes?: Array<string | null | undefined> | null | undefined;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type RoleLiteFieldsFragment = {
  __typename: "PersonRole";
  id?: string | null | undefined;
  obj_id?: number | null | undefined;
  role?: string | null | undefined;
  type?: string | null | undefined;
  access_level?: string | null | undefined;
  person_id?: number | null | undefined;
};

export const RoleFieldsFragmentDoc = gql`
  fragment RoleFields on PersonRole {
    id
    obj_id
    role
    type
    access_level
    person_id
    actions
    administration {
      id
      can_change_access_level
      can_change_role
      can_invite
      can_revoke
      max_grant_role
      max_grant_access_level
      grantable_roles
      grantable_access_levels
      constraints {
        organization_full_implies_admin
        workspace_admin_edit_no_manage_people
        notes
      }
    }
  }
`;
export const RoleLiteFieldsFragmentDoc = gql`
  fragment RoleLiteFields on PersonRole {
    id
    obj_id
    role
    type
    access_level
    person_id
  }
`;
export const AddPeopleDocument = gql`
  mutation AddPeople($people: [AddPersonInput]) {
    addPeople(people: $people) {
      message
      success
    }
  }
`;
export type AddPeopleMutationFn = Apollo.MutationFunction<
  AddPeopleMutation,
  AddPeopleMutationVariables
>;

/**
 * __useAddPeopleMutation__
 *
 * To run a mutation, you first call `useAddPeopleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPeopleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPeopleMutation, { data, loading, error }] = useAddPeopleMutation({
 *   variables: {
 *      people: // value for 'people'
 *   },
 * });
 */
export function useAddPeopleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddPeopleMutation,
    AddPeopleMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AddPeopleMutation, AddPeopleMutationVariables>(
    AddPeopleDocument,
    options
  );
}
export type AddPeopleMutationHookResult = ReturnType<
  typeof useAddPeopleMutation
>;
export type AddPeopleMutationResult = Apollo.MutationResult<AddPeopleMutation>;
export type AddPeopleMutationOptions = Apollo.BaseMutationOptions<
  AddPeopleMutation,
  AddPeopleMutationVariables
>;
export const EvaluatePersonDocument = gql`
  mutation EvaluatePerson(
    $personId: Int
    $rowId: Int
    $assessmentId: Int
    $evaluation: Int
    $meta: JSONObject
  ) {
    evaluatePerson(
      person_id: $personId
      row_id: $rowId
      assessment_id: $assessmentId
      evaluation: $evaluation
      meta: $meta
    ) {
      id
      row_id
      person_id
      evaluation
      created_at
      created_by
      meta
    }
  }
`;
export type EvaluatePersonMutationFn = Apollo.MutationFunction<
  EvaluatePersonMutation,
  EvaluatePersonMutationVariables
>;

/**
 * __useEvaluatePersonMutation__
 *
 * To run a mutation, you first call `useEvaluatePersonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEvaluatePersonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [evaluatePersonMutation, { data, loading, error }] = useEvaluatePersonMutation({
 *   variables: {
 *      personId: // value for 'personId'
 *      rowId: // value for 'rowId'
 *      assessmentId: // value for 'assessmentId'
 *      evaluation: // value for 'evaluation'
 *      meta: // value for 'meta'
 *   },
 * });
 */
export function useEvaluatePersonMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EvaluatePersonMutation,
    EvaluatePersonMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    EvaluatePersonMutation,
    EvaluatePersonMutationVariables
  >(EvaluatePersonDocument, options);
}
export type EvaluatePersonMutationHookResult = ReturnType<
  typeof useEvaluatePersonMutation
>;
export type EvaluatePersonMutationResult =
  Apollo.MutationResult<EvaluatePersonMutation>;
export type EvaluatePersonMutationOptions = Apollo.BaseMutationOptions<
  EvaluatePersonMutation,
  EvaluatePersonMutationVariables
>;
export const RemovePersonFromOrganizationDocument = gql`
  mutation RemovePersonFromOrganization($orgId: Int, $personId: Int) {
    removePersonFromOrganization(org_id: $orgId, person_id: $personId) {
      message
      success
    }
  }
`;
export type RemovePersonFromOrganizationMutationFn = Apollo.MutationFunction<
  RemovePersonFromOrganizationMutation,
  RemovePersonFromOrganizationMutationVariables
>;

/**
 * __useRemovePersonFromOrganizationMutation__
 *
 * To run a mutation, you first call `useRemovePersonFromOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePersonFromOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePersonFromOrganizationMutation, { data, loading, error }] = useRemovePersonFromOrganizationMutation({
 *   variables: {
 *      orgId: // value for 'orgId'
 *      personId: // value for 'personId'
 *   },
 * });
 */
export function useRemovePersonFromOrganizationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemovePersonFromOrganizationMutation,
    RemovePersonFromOrganizationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemovePersonFromOrganizationMutation,
    RemovePersonFromOrganizationMutationVariables
  >(RemovePersonFromOrganizationDocument, options);
}
export type RemovePersonFromOrganizationMutationHookResult = ReturnType<
  typeof useRemovePersonFromOrganizationMutation
>;
export type RemovePersonFromOrganizationMutationResult =
  Apollo.MutationResult<RemovePersonFromOrganizationMutation>;
export type RemovePersonFromOrganizationMutationOptions =
  Apollo.BaseMutationOptions<
    RemovePersonFromOrganizationMutation,
    RemovePersonFromOrganizationMutationVariables
  >;
export const RemovePersonFromWorkspaceDocument = gql`
  mutation RemovePersonFromWorkspace($personId: Int!) {
    removePersonFromWorkspace(person_id: $personId) {
      ids
      message
      success
    }
  }
`;
export type RemovePersonFromWorkspaceMutationFn = Apollo.MutationFunction<
  RemovePersonFromWorkspaceMutation,
  RemovePersonFromWorkspaceMutationVariables
>;

/**
 * __useRemovePersonFromWorkspaceMutation__
 *
 * To run a mutation, you first call `useRemovePersonFromWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePersonFromWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePersonFromWorkspaceMutation, { data, loading, error }] = useRemovePersonFromWorkspaceMutation({
 *   variables: {
 *      personId: // value for 'personId'
 *   },
 * });
 */
export function useRemovePersonFromWorkspaceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemovePersonFromWorkspaceMutation,
    RemovePersonFromWorkspaceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemovePersonFromWorkspaceMutation,
    RemovePersonFromWorkspaceMutationVariables
  >(RemovePersonFromWorkspaceDocument, options);
}
export type RemovePersonFromWorkspaceMutationHookResult = ReturnType<
  typeof useRemovePersonFromWorkspaceMutation
>;
export type RemovePersonFromWorkspaceMutationResult =
  Apollo.MutationResult<RemovePersonFromWorkspaceMutation>;
export type RemovePersonFromWorkspaceMutationOptions =
  Apollo.BaseMutationOptions<
    RemovePersonFromWorkspaceMutation,
    RemovePersonFromWorkspaceMutationVariables
  >;
export const ResendInviteDocument = gql`
  mutation ResendInvite($personId: Int!) {
    resendInvite(person_id: $personId) {
      message
      success
    }
  }
`;
export type ResendInviteMutationFn = Apollo.MutationFunction<
  ResendInviteMutation,
  ResendInviteMutationVariables
>;

/**
 * __useResendInviteMutation__
 *
 * To run a mutation, you first call `useResendInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendInviteMutation, { data, loading, error }] = useResendInviteMutation({
 *   variables: {
 *      personId: // value for 'personId'
 *   },
 * });
 */
export function useResendInviteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResendInviteMutation,
    ResendInviteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ResendInviteMutation,
    ResendInviteMutationVariables
  >(ResendInviteDocument, options);
}
export type ResendInviteMutationHookResult = ReturnType<
  typeof useResendInviteMutation
>;
export type ResendInviteMutationResult =
  Apollo.MutationResult<ResendInviteMutation>;
export type ResendInviteMutationOptions = Apollo.BaseMutationOptions<
  ResendInviteMutation,
  ResendInviteMutationVariables
>;
export const SendContactInviteDocument = gql`
  mutation SendContactInvite($projectId: Int!, $personId: Int!) {
    sendContactInvite(person_id: $personId, project_id: $projectId) {
      message
      success
    }
  }
`;
export type SendContactInviteMutationFn = Apollo.MutationFunction<
  SendContactInviteMutation,
  SendContactInviteMutationVariables
>;

/**
 * __useSendContactInviteMutation__
 *
 * To run a mutation, you first call `useSendContactInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendContactInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendContactInviteMutation, { data, loading, error }] = useSendContactInviteMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      personId: // value for 'personId'
 *   },
 * });
 */
export function useSendContactInviteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendContactInviteMutation,
    SendContactInviteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SendContactInviteMutation,
    SendContactInviteMutationVariables
  >(SendContactInviteDocument, options);
}
export type SendContactInviteMutationHookResult = ReturnType<
  typeof useSendContactInviteMutation
>;
export type SendContactInviteMutationResult =
  Apollo.MutationResult<SendContactInviteMutation>;
export type SendContactInviteMutationOptions = Apollo.BaseMutationOptions<
  SendContactInviteMutation,
  SendContactInviteMutationVariables
>;
export const SendProfileReminderDocument = gql`
  mutation SendProfileReminder($personId: Int!) {
    sendProfileReminder(person_id: $personId)
  }
`;
export type SendProfileReminderMutationFn = Apollo.MutationFunction<
  SendProfileReminderMutation,
  SendProfileReminderMutationVariables
>;

/**
 * __useSendProfileReminderMutation__
 *
 * To run a mutation, you first call `useSendProfileReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendProfileReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendProfileReminderMutation, { data, loading, error }] = useSendProfileReminderMutation({
 *   variables: {
 *      personId: // value for 'personId'
 *   },
 * });
 */
export function useSendProfileReminderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendProfileReminderMutation,
    SendProfileReminderMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SendProfileReminderMutation,
    SendProfileReminderMutationVariables
  >(SendProfileReminderDocument, options);
}
export type SendProfileReminderMutationHookResult = ReturnType<
  typeof useSendProfileReminderMutation
>;
export type SendProfileReminderMutationResult =
  Apollo.MutationResult<SendProfileReminderMutation>;
export type SendProfileReminderMutationOptions = Apollo.BaseMutationOptions<
  SendProfileReminderMutation,
  SendProfileReminderMutationVariables
>;
export const UpsertPersonScoreDocument = gql`
  mutation UpsertPersonScore($dimId: Int!, $score: Float!, $personId: Int!) {
    upsertPersonScore(dim_id: $dimId, score: $score, person_id: $personId) {
      dim_id
      code
      group
      group_title
      parent
      parent_id
      parent_title
      scores {
        obj_type
        obj_id
        key
        value
      }
    }
  }
`;
export type UpsertPersonScoreMutationFn = Apollo.MutationFunction<
  UpsertPersonScoreMutation,
  UpsertPersonScoreMutationVariables
>;

/**
 * __useUpsertPersonScoreMutation__
 *
 * To run a mutation, you first call `useUpsertPersonScoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPersonScoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPersonScoreMutation, { data, loading, error }] = useUpsertPersonScoreMutation({
 *   variables: {
 *      dimId: // value for 'dimId'
 *      score: // value for 'score'
 *      personId: // value for 'personId'
 *   },
 * });
 */
export function useUpsertPersonScoreMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpsertPersonScoreMutation,
    UpsertPersonScoreMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpsertPersonScoreMutation,
    UpsertPersonScoreMutationVariables
  >(UpsertPersonScoreDocument, options);
}
export type UpsertPersonScoreMutationHookResult = ReturnType<
  typeof useUpsertPersonScoreMutation
>;
export type UpsertPersonScoreMutationResult =
  Apollo.MutationResult<UpsertPersonScoreMutation>;
export type UpsertPersonScoreMutationOptions = Apollo.BaseMutationOptions<
  UpsertPersonScoreMutation,
  UpsertPersonScoreMutationVariables
>;
export const UpsertPersonDocument = gql`
  mutation UpsertPerson(
    $personId: Int!
    $email: String
    $firstName: String
    $lastName: String
    $phone: String
    $linkedin: String
  ) {
    upsertPerson(
      person_id: $personId
      email: $email
      first_name: $firstName
      last_name: $lastName
      phone: $phone
      linkedin: $linkedin
    ) {
      message
      success
    }
  }
`;
export type UpsertPersonMutationFn = Apollo.MutationFunction<
  UpsertPersonMutation,
  UpsertPersonMutationVariables
>;

/**
 * __useUpsertPersonMutation__
 *
 * To run a mutation, you first call `useUpsertPersonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPersonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPersonMutation, { data, loading, error }] = useUpsertPersonMutation({
 *   variables: {
 *      personId: // value for 'personId'
 *      email: // value for 'email'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      phone: // value for 'phone'
 *      linkedin: // value for 'linkedin'
 *   },
 * });
 */
export function useUpsertPersonMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpsertPersonMutation,
    UpsertPersonMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpsertPersonMutation,
    UpsertPersonMutationVariables
  >(UpsertPersonDocument, options);
}
export type UpsertPersonMutationHookResult = ReturnType<
  typeof useUpsertPersonMutation
>;
export type UpsertPersonMutationResult =
  Apollo.MutationResult<UpsertPersonMutation>;
export type UpsertPersonMutationOptions = Apollo.BaseMutationOptions<
  UpsertPersonMutation,
  UpsertPersonMutationVariables
>;
export const UpsertPersonAccessLevelDocument = gql`
  mutation UpsertPersonAccessLevel(
    $personId: Int!
    $type: String!
    $access_level: String!
    $objectId: Int!
  ) {
    upsertPersonAccessLevel(
      person_id: $personId
      type: $type
      access_level: $access_level
      id: $objectId
    ) {
      message
      success
    }
  }
`;
export type UpsertPersonAccessLevelMutationFn = Apollo.MutationFunction<
  UpsertPersonAccessLevelMutation,
  UpsertPersonAccessLevelMutationVariables
>;

/**
 * __useUpsertPersonAccessLevelMutation__
 *
 * To run a mutation, you first call `useUpsertPersonAccessLevelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPersonAccessLevelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPersonAccessLevelMutation, { data, loading, error }] = useUpsertPersonAccessLevelMutation({
 *   variables: {
 *      personId: // value for 'personId'
 *      type: // value for 'type'
 *      access_level: // value for 'access_level'
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useUpsertPersonAccessLevelMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpsertPersonAccessLevelMutation,
    UpsertPersonAccessLevelMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpsertPersonAccessLevelMutation,
    UpsertPersonAccessLevelMutationVariables
  >(UpsertPersonAccessLevelDocument, options);
}
export type UpsertPersonAccessLevelMutationHookResult = ReturnType<
  typeof useUpsertPersonAccessLevelMutation
>;
export type UpsertPersonAccessLevelMutationResult =
  Apollo.MutationResult<UpsertPersonAccessLevelMutation>;
export type UpsertPersonAccessLevelMutationOptions = Apollo.BaseMutationOptions<
  UpsertPersonAccessLevelMutation,
  UpsertPersonAccessLevelMutationVariables
>;
export const UpsertPersonNoteDocument = gql`
  mutation UpsertPersonNote(
    $personId: Int!
    $note: String!
    $type: String!
    $id: Int
  ) {
    upsertPersonNote(person_id: $personId, note: $note, type: $type, id: $id) {
      id
      person_id
      note
      type
      created_by
      updated_at
      created_at
    }
  }
`;
export type UpsertPersonNoteMutationFn = Apollo.MutationFunction<
  UpsertPersonNoteMutation,
  UpsertPersonNoteMutationVariables
>;

/**
 * __useUpsertPersonNoteMutation__
 *
 * To run a mutation, you first call `useUpsertPersonNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPersonNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPersonNoteMutation, { data, loading, error }] = useUpsertPersonNoteMutation({
 *   variables: {
 *      personId: // value for 'personId'
 *      note: // value for 'note'
 *      type: // value for 'type'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpsertPersonNoteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpsertPersonNoteMutation,
    UpsertPersonNoteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpsertPersonNoteMutation,
    UpsertPersonNoteMutationVariables
  >(UpsertPersonNoteDocument, options);
}
export type UpsertPersonNoteMutationHookResult = ReturnType<
  typeof useUpsertPersonNoteMutation
>;
export type UpsertPersonNoteMutationResult =
  Apollo.MutationResult<UpsertPersonNoteMutation>;
export type UpsertPersonNoteMutationOptions = Apollo.BaseMutationOptions<
  UpsertPersonNoteMutation,
  UpsertPersonNoteMutationVariables
>;
export const UpsertPersonRoleDocument = gql`
  mutation UpsertPersonRole(
    $personId: Int!
    $type: String!
    $role: String!
    $objectId: Int!
  ) {
    upsertPersonRole(
      person_id: $personId
      type: $type
      role: $role
      id: $objectId
    ) {
      message
      success
    }
  }
`;
export type UpsertPersonRoleMutationFn = Apollo.MutationFunction<
  UpsertPersonRoleMutation,
  UpsertPersonRoleMutationVariables
>;

/**
 * __useUpsertPersonRoleMutation__
 *
 * To run a mutation, you first call `useUpsertPersonRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPersonRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPersonRoleMutation, { data, loading, error }] = useUpsertPersonRoleMutation({
 *   variables: {
 *      personId: // value for 'personId'
 *      type: // value for 'type'
 *      role: // value for 'role'
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useUpsertPersonRoleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpsertPersonRoleMutation,
    UpsertPersonRoleMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpsertPersonRoleMutation,
    UpsertPersonRoleMutationVariables
  >(UpsertPersonRoleDocument, options);
}
export type UpsertPersonRoleMutationHookResult = ReturnType<
  typeof useUpsertPersonRoleMutation
>;
export type UpsertPersonRoleMutationResult =
  Apollo.MutationResult<UpsertPersonRoleMutation>;
export type UpsertPersonRoleMutationOptions = Apollo.BaseMutationOptions<
  UpsertPersonRoleMutation,
  UpsertPersonRoleMutationVariables
>;
export const UpsertPersonScoresBulkDocument = gql`
  mutation UpsertPersonScoresBulk($personId: Int!, $scores: [ScoreInput]!) {
    upsertPersonScoresBulk(person_id: $personId, scores: $scores) {
      message
      success
    }
  }
`;
export type UpsertPersonScoresBulkMutationFn = Apollo.MutationFunction<
  UpsertPersonScoresBulkMutation,
  UpsertPersonScoresBulkMutationVariables
>;

/**
 * __useUpsertPersonScoresBulkMutation__
 *
 * To run a mutation, you first call `useUpsertPersonScoresBulkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPersonScoresBulkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPersonScoresBulkMutation, { data, loading, error }] = useUpsertPersonScoresBulkMutation({
 *   variables: {
 *      personId: // value for 'personId'
 *      scores: // value for 'scores'
 *   },
 * });
 */
export function useUpsertPersonScoresBulkMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpsertPersonScoresBulkMutation,
    UpsertPersonScoresBulkMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpsertPersonScoresBulkMutation,
    UpsertPersonScoresBulkMutationVariables
  >(UpsertPersonScoresBulkDocument, options);
}
export type UpsertPersonScoresBulkMutationHookResult = ReturnType<
  typeof useUpsertPersonScoresBulkMutation
>;
export type UpsertPersonScoresBulkMutationResult =
  Apollo.MutationResult<UpsertPersonScoresBulkMutation>;
export type UpsertPersonScoresBulkMutationOptions = Apollo.BaseMutationOptions<
  UpsertPersonScoresBulkMutation,
  UpsertPersonScoresBulkMutationVariables
>;
export const ValidatePeopleByEmailDocument = gql`
  mutation ValidatePeopleByEmail(
    $emails: [String]
    $resource: ResourceType
    $resourceId: Int
  ) {
    validatePeopleByEmail(
      emails: $emails
      resource: $resource
      resourceId: $resourceId
    ) {
      people {
        id
        first_name
        last_name
        name
        email
        avatar
        initials
        linkedin
        phone
        invite {
          created_at
          secret
        }
        roles {
          ...RoleLiteFields
        }
        survey_completion {
          survey_id
          survey_type
          text_id
          completed
        }
        is_contact
      }
    }
  }
  ${RoleLiteFieldsFragmentDoc}
`;
export type ValidatePeopleByEmailMutationFn = Apollo.MutationFunction<
  ValidatePeopleByEmailMutation,
  ValidatePeopleByEmailMutationVariables
>;

/**
 * __useValidatePeopleByEmailMutation__
 *
 * To run a mutation, you first call `useValidatePeopleByEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidatePeopleByEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validatePeopleByEmailMutation, { data, loading, error }] = useValidatePeopleByEmailMutation({
 *   variables: {
 *      emails: // value for 'emails'
 *      resource: // value for 'resource'
 *      resourceId: // value for 'resourceId'
 *   },
 * });
 */
export function useValidatePeopleByEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ValidatePeopleByEmailMutation,
    ValidatePeopleByEmailMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ValidatePeopleByEmailMutation,
    ValidatePeopleByEmailMutationVariables
  >(ValidatePeopleByEmailDocument, options);
}
export type ValidatePeopleByEmailMutationHookResult = ReturnType<
  typeof useValidatePeopleByEmailMutation
>;
export type ValidatePeopleByEmailMutationResult =
  Apollo.MutationResult<ValidatePeopleByEmailMutation>;
export type ValidatePeopleByEmailMutationOptions = Apollo.BaseMutationOptions<
  ValidatePeopleByEmailMutation,
  ValidatePeopleByEmailMutationVariables
>;
export const ValidatePersonByEmailDocument = gql`
  mutation ValidatePersonByEmail($email: String) {
    validatePersonByEmail(email: $email) {
      person {
        email
        id
        first_name
        last_name
        name
        avatar
        roles {
          ...RoleLiteFields
        }
      }
    }
  }
  ${RoleLiteFieldsFragmentDoc}
`;
export type ValidatePersonByEmailMutationFn = Apollo.MutationFunction<
  ValidatePersonByEmailMutation,
  ValidatePersonByEmailMutationVariables
>;

/**
 * __useValidatePersonByEmailMutation__
 *
 * To run a mutation, you first call `useValidatePersonByEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidatePersonByEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validatePersonByEmailMutation, { data, loading, error }] = useValidatePersonByEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useValidatePersonByEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ValidatePersonByEmailMutation,
    ValidatePersonByEmailMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ValidatePersonByEmailMutation,
    ValidatePersonByEmailMutationVariables
  >(ValidatePersonByEmailDocument, options);
}
export type ValidatePersonByEmailMutationHookResult = ReturnType<
  typeof useValidatePersonByEmailMutation
>;
export type ValidatePersonByEmailMutationResult =
  Apollo.MutationResult<ValidatePersonByEmailMutation>;
export type ValidatePersonByEmailMutationOptions = Apollo.BaseMutationOptions<
  ValidatePersonByEmailMutation,
  ValidatePersonByEmailMutationVariables
>;
export const EvaluationsDocument = gql`
  query Evaluations($personId: Int, $projectId: Int, $assessmentId: Int) {
    evaluations(
      person_id: $personId
      project_id: $projectId
      assessment_id: $assessmentId
    ) {
      id
      row_id
      person_id
      evaluation
      created_at
      created_by
      meta
    }
  }
`;

/**
 * __useEvaluationsQuery__
 *
 * To run a query within a React component, call `useEvaluationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEvaluationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEvaluationsQuery({
 *   variables: {
 *      personId: // value for 'personId'
 *      projectId: // value for 'projectId'
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useEvaluationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    EvaluationsQuery,
    EvaluationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<EvaluationsQuery, EvaluationsQueryVariables>(
    EvaluationsDocument,
    options
  );
}
export function useEvaluationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EvaluationsQuery,
    EvaluationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<EvaluationsQuery, EvaluationsQueryVariables>(
    EvaluationsDocument,
    options
  );
}
export function useEvaluationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        EvaluationsQuery,
        EvaluationsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<EvaluationsQuery, EvaluationsQueryVariables>(
    EvaluationsDocument,
    options
  );
}
export type EvaluationsQueryHookResult = ReturnType<typeof useEvaluationsQuery>;
export type EvaluationsLazyQueryHookResult = ReturnType<
  typeof useEvaluationsLazyQuery
>;
export type EvaluationsSuspenseQueryHookResult = ReturnType<
  typeof useEvaluationsSuspenseQuery
>;
export type EvaluationsQueryResult = Apollo.QueryResult<
  EvaluationsQuery,
  EvaluationsQueryVariables
>;
export const PeopleDocument = gql`
  query People($filter: PeopleFilter) {
    people(filter: $filter) {
      id
      first_name
      last_name
      name
      email
      avatar
      initials
      linkedin
      phone
      invite {
        created_at
        secret
      }
      roles {
        ...RoleLiteFields
      }
      is_contact
      survey_completion {
        survey_id
        survey_type
        text_id
        completed
      }
      completed_dim_types
    }
  }
  ${RoleLiteFieldsFragmentDoc}
`;

/**
 * __usePeopleQuery__
 *
 * To run a query within a React component, call `usePeopleQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeopleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeopleQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePeopleQuery(
  baseOptions?: Apollo.QueryHookOptions<PeopleQuery, PeopleQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PeopleQuery, PeopleQueryVariables>(
    PeopleDocument,
    options
  );
}
export function usePeopleLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<PeopleQuery, PeopleQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PeopleQuery, PeopleQueryVariables>(
    PeopleDocument,
    options
  );
}
export function usePeopleSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PeopleQuery, PeopleQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<PeopleQuery, PeopleQueryVariables>(
    PeopleDocument,
    options
  );
}
export type PeopleQueryHookResult = ReturnType<typeof usePeopleQuery>;
export type PeopleLazyQueryHookResult = ReturnType<typeof usePeopleLazyQuery>;
export type PeopleSuspenseQueryHookResult = ReturnType<
  typeof usePeopleSuspenseQuery
>;
export type PeopleQueryResult = Apollo.QueryResult<
  PeopleQuery,
  PeopleQueryVariables
>;
export const PersonDocument = gql`
  query Person($personId: Int!) {
    person(id: $personId) {
      id
      first_name
      last_name
      name
      email
      avatar
      initials
      linkedin
      phone
      invite {
        created_at
        secret
      }
      is_contact
      roles {
        ...RoleLiteFields
      }
      survey_completion {
        survey_id
        survey_type
        text_id
        completed
      }
      completed_dim_types
    }
  }
  ${RoleLiteFieldsFragmentDoc}
`;

/**
 * __usePersonQuery__
 *
 * To run a query within a React component, call `usePersonQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonQuery({
 *   variables: {
 *      personId: // value for 'personId'
 *   },
 * });
 */
export function usePersonQuery(
  baseOptions: Apollo.QueryHookOptions<PersonQuery, PersonQueryVariables> &
    ({ variables: PersonQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PersonQuery, PersonQueryVariables>(
    PersonDocument,
    options
  );
}
export function usePersonLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<PersonQuery, PersonQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PersonQuery, PersonQueryVariables>(
    PersonDocument,
    options
  );
}
export function usePersonSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PersonQuery, PersonQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<PersonQuery, PersonQueryVariables>(
    PersonDocument,
    options
  );
}
export type PersonQueryHookResult = ReturnType<typeof usePersonQuery>;
export type PersonLazyQueryHookResult = ReturnType<typeof usePersonLazyQuery>;
export type PersonSuspenseQueryHookResult = ReturnType<
  typeof usePersonSuspenseQuery
>;
export type PersonQueryResult = Apollo.QueryResult<
  PersonQuery,
  PersonQueryVariables
>;
export const PersonNotesDocument = gql`
  query PersonNotes($filter: PersonNotesFilter) {
    personNotes(filter: $filter) {
      id
      person_id
      note
      type
      created_by
      updated_at
      created_at
    }
  }
`;

/**
 * __usePersonNotesQuery__
 *
 * To run a query within a React component, call `usePersonNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonNotesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePersonNotesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PersonNotesQuery,
    PersonNotesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PersonNotesQuery, PersonNotesQueryVariables>(
    PersonNotesDocument,
    options
  );
}
export function usePersonNotesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PersonNotesQuery,
    PersonNotesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PersonNotesQuery, PersonNotesQueryVariables>(
    PersonNotesDocument,
    options
  );
}
export function usePersonNotesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PersonNotesQuery,
        PersonNotesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<PersonNotesQuery, PersonNotesQueryVariables>(
    PersonNotesDocument,
    options
  );
}
export type PersonNotesQueryHookResult = ReturnType<typeof usePersonNotesQuery>;
export type PersonNotesLazyQueryHookResult = ReturnType<
  typeof usePersonNotesLazyQuery
>;
export type PersonNotesSuspenseQueryHookResult = ReturnType<
  typeof usePersonNotesSuspenseQuery
>;
export type PersonNotesQueryResult = Apollo.QueryResult<
  PersonNotesQuery,
  PersonNotesQueryVariables
>;
export const ShareCandidateProfileDocument = gql`
  query ShareCandidateProfile($personId: Int!, $projectId: Int!, $orgId: Int!) {
    shareCandidateProfile(
      person_id: $personId
      project_id: $projectId
      org_id: $orgId
    )
  }
`;

/**
 * __useShareCandidateProfileQuery__
 *
 * To run a query within a React component, call `useShareCandidateProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useShareCandidateProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShareCandidateProfileQuery({
 *   variables: {
 *      personId: // value for 'personId'
 *      projectId: // value for 'projectId'
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useShareCandidateProfileQuery(
  baseOptions: Apollo.QueryHookOptions<
    ShareCandidateProfileQuery,
    ShareCandidateProfileQueryVariables
  > &
    (
      | { variables: ShareCandidateProfileQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ShareCandidateProfileQuery,
    ShareCandidateProfileQueryVariables
  >(ShareCandidateProfileDocument, options);
}
export function useShareCandidateProfileLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ShareCandidateProfileQuery,
    ShareCandidateProfileQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ShareCandidateProfileQuery,
    ShareCandidateProfileQueryVariables
  >(ShareCandidateProfileDocument, options);
}
export function useShareCandidateProfileSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ShareCandidateProfileQuery,
        ShareCandidateProfileQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ShareCandidateProfileQuery,
    ShareCandidateProfileQueryVariables
  >(ShareCandidateProfileDocument, options);
}
export type ShareCandidateProfileQueryHookResult = ReturnType<
  typeof useShareCandidateProfileQuery
>;
export type ShareCandidateProfileLazyQueryHookResult = ReturnType<
  typeof useShareCandidateProfileLazyQuery
>;
export type ShareCandidateProfileSuspenseQueryHookResult = ReturnType<
  typeof useShareCandidateProfileSuspenseQuery
>;
export type ShareCandidateProfileQueryResult = Apollo.QueryResult<
  ShareCandidateProfileQuery,
  ShareCandidateProfileQueryVariables
>;
